import React, { useEffect } from 'react';
import ViewportIndicator from './viewportIndicator';
import styles from './index.module.scss';

const MOBILE_USER_AGENT =
  'Mozilla/5.0 (iPhone; CPU iPhone OS 14_0 like Mac OS X) AppleWebKit/605.1.15 (KHTML, like Gecko) Version/14.0 Mobile/15E148 Safari/604.1';

const viewportConfigs = {
  ios: {
    width: 390,
    height: 844,
  },
  android: {
    width: 360,
    height: 800,
  },
  web: {
    width: 1440,
    height: 900,
  },
  selfserve: {
    width: 1440,
    height: 900,
  },
} as const;

function ViewportWrapper({
  platform,
  children,
  setPlatform,
  onChangeApp,
}: {
  platform: string;
  children: React.ReactNode;
  setPlatform: (arg0) => void;
  onChangeApp: () => void;
}) {
  useEffect(() => {
    if (platform) {
      // Only mock user agent for mobile platforms
      if (platform === 'ios' || platform === 'android') {
        Object.defineProperty(navigator, 'userAgent', {
          get: () => MOBILE_USER_AGENT,
          configurable: true,
        });
      }

      document.body.classList.add(styles.mockWrapper);

      const root = document.getElementById('root');
      if (root) {
        const { width, height } = viewportConfigs[platform];
        root.className = styles.mockContainer;
        root.style.cssText = `width:${width}px;min-width:${width}px;max-width:${width}px;height:${height}px`;
      }
    }

    // eslint-disable-next-line consistent-return
    return () => {
      // Reset userAgent if it was mocked
      if (platform === 'ios' || platform === 'android') {
        // @ts-ignore
        delete navigator.userAgent;
      }
      document.body.classList.remove(styles.mockWrapper);
      const root = document.getElementById('root');
      if (root) {
        root.className = '';
        root.removeAttribute('style');
      }
    };
  }, [platform]);

  if (!platform) return children;

  const { width, height } = viewportConfigs[platform];

  return (
    <>
      {children}
      <ViewportIndicator
        platform={platform as any}
        setPlatform={setPlatform}
        width={width}
        height={height}
        onChangeApp={onChangeApp}
      />
    </>
  );
}

export default ViewportWrapper;
